import { WIX_MINI_FILTER_EVENT_NAME } from '@va/constants';
import { Filter, FilterTypes, isNestedFiltersPage } from '@va/types/filters';
import { isWixMiniApp } from '@va/util/helpers';
import { DashboardAppWorker } from '@va/util/misc';
import { useCallback, useState } from 'react';
import { FilterOptions, useFiltersContext } from '../filters-context';
import { BooleanFilter } from '../general-filter-inputs';
import { AvailableFiltersList } from './AvailableFiltersList';
import { IndividualFilter } from './IndividualFilter';

export const AddNewFilterTab = ({ closeDropdown }: { closeDropdown: () => void }) => {
  const { allFilterOptions, isFilterApplied, isExpanded, applySingleNewFilter, deleteAppliedFilter } =
    useFiltersContext();

  const [titles, setTitles] = useState<string[]>([]);
  const [filters, setFilters] = useState<FilterOptions[]>([
    allFilterOptions.sort((a, b) => {
      if (a.premium && !b.premium) return -1;
      if (!a.premium && b.premium) return 1;
      return a.label.localeCompare(b.label);
    }),
  ]);
  const [selectedFilter, setSelectedFilter] = useState<Filter | undefined>(undefined);
  const filtersOnCurrentPage = filters[filters.length - 1];
  const titleOnCurrentPage = titles[titles.length - 1];

  const onClose = useCallback(() => {
    closeDropdown();
    setSelectedFilter(undefined);
  }, [closeDropdown]);

  return (
    <>
      {!selectedFilter && (
        <AvailableFiltersList
          closeDropdown={onClose}
          onFilterClick={(item) => {
            if (isWixMiniApp()) {
              const filterEventName = WIX_MINI_FILTER_EVENT_NAME[item.name];

              if (filterEventName) {
                DashboardAppWorker.trackEvent({
                  category: 'Recording Main View',
                  action: 'onclick',
                  label: `Add/Edit Filter ${filterEventName}`,
                  value: 'Button',
                });
              }
            }

            if (isNestedFiltersPage(item)) {
              setFilters((prev) => [...prev, item.filters]);
              setTitles((prev) => [...prev, item.label]);
              return;
            }

            if (item.type === FilterTypes.Boolean) {
              const appliedFilter = isFilterApplied(item.id);

              if (appliedFilter) {
                if (isExpanded) closeDropdown();
                deleteAppliedFilter(item.id);
                return;
              }

              applySingleNewFilter(new BooleanFilter({ ...item, values: [true] }));
              return;
            }

            setSelectedFilter(item);
          }}
          title={titleOnCurrentPage}
          onBackClick={() => {
            if (filters.length > 1) {
              setFilters((prev) => {
                return prev.slice(0, prev.length - 1);
              });
              setTitles((prev) => {
                return prev.slice(0, prev.length - 1);
              });
            }
          }}
          availableFilters={filtersOnCurrentPage}
        />
      )}
      {selectedFilter && (
        <IndividualFilter
          onBackClick={() => {
            setSelectedFilter(undefined);
          }}
          filter={selectedFilter}
          onClose={onClose}
        />
      )}
    </>
  );
};
